// pages/Highlights.jsx
import React, { useState } from "react";
import "../styles/Highlights.css";
import "../styles/Post.css";
import {
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaMicrophone
  // FaTimes
} from "react-icons/fa";
// import ReactModal from "react-modal";

const Highlights = () => {
  const [activeTab1, setActiveTab1] = useState("2018");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeVideo, setActiveVideo] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    // setIsModalOpen(true);
  };
  // const closeModal = () => {
  //   setIsModalOpen(false);
  // };

  const mainContentItems = [
    {
      title: "ஜி.டி.நாயுடு விருதுக்கு ஜூலை 25-க்குள் விண்ணப்பிக்கலாம்",
      title1: "சிறந்த அறிவியலாளருக்கு ஜி.டி.நாயுடு விருது",
      description: `ஈரோடு, ஜூலை 20: ஈரோடு புத்தகத்திருவிழாவை முன்னிட்டு வழங்கப்படும் ஜி.டி.நாயுடு விருதுக்கு அறிவியலாளர்கள் வரும் 25 ஆம் தேதிக்குள் விண்ணப்பிக்க வேண்டும் என மக்கள் சிந்தனைப் பேரவை அறிவித்துள்ளது.
  
          தமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும் ஈரோடு புத்தகத் திருவிழாவில் ஆண்டுதோறும் சிறந்த இளம் அறிவியலாளர் ஒருவருக்கு மக்கள் சிந்தனைப் பேரவையின் சார்பில் அறிவியல் மேதை ஜி.டி. நாயுடு விருது என்ற பெயரில் சிறப்பு விருது வழங்கப்படுகிறது. இவ்விருதுக்காக அளிக்கப்படும் ரூபாய் ஒரு லட்சம் பரிசுத் தொகையை சிங்கப்பூர் முஸ்தபா தமிழ் அறக்கட்டளை வழங்குகிறது.
  
          விருதாளர் 40 வயதுக்கு உள்பட்ட இளம் அறிவியலாளராக விளங்குதல், பல்கலைக்கழகங்கள் மற்றும் கல்லூரிகளில் உள்ள ஆய்வுக்கூடங்களிலோ அல்லது அங்கீகரிக்கப்பட்ட வேறு ஆய்வுக்கூடங்களிலோ ஆய்வுகளை மேற்கொள்தல், பெயர் பெற்ற சர்வதேச அறிவியல் இதழ்களில் குறைந்தபட்சம் பத்து ஆய்வுக் கட்டுரைகள் வெளிவந்திருத்தல் உள்ளிட்ட சில அடிப்படைத் தகுதிகள் உள்ளவர்கள் தங்களது ஆய்வு விவரக் குறிப்புகளை அனுப்பலாம்.
  
          எந்தக் கண்டுபிடிப்புக்கு ஆய்வாளர் விருதுக்குரியவராக விளங்குகிறார் என்பதை சுருக்கமாகவும் தெளிவாகவும் குறிப்பிடுதல் அவசியம். ஆய்வுக் குறிப்புகளையும் ஆய்வு தொடர்பான அனைத்து ஆவணங்களையும் வரும் 25-ஆம் தேதிக்குள் info@makkalsinthanaiperavai.org என்ற மின்னஞ்சல் முகவரிக்கு அனுப்பி வைக்க வேண்டும்.`,
      description1:
        "ஈரோடு புத்தகத்திருவிழாவில், மக்கள் சிந்தனைப் பேரவை சார்பில் வழங்கப்படவுள்ள சிறந்த அறிவியலாளருக்கான ஜி.டி.நாயுடு விருதுக்கு விண்ணப்பிக்க அழைப்பு விடுக்கப்பட்டுள்ளது.தமிழக அரசு மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும் ஈரோடு புத்தகத் திருவிழாவில் ஆண்டுதோறும் சிறந்த இளம் அறிவியலாளர் ஒருவருக்கு மக்கள் சிந்தனைப் பேரவையின் சார்பில் 'அறிவியல் மேதை ஜி.டி. நாயுடு விருது' என்ற பெயரில் சிறப்பு விருது வழங்கப்படுகிறது. இவ்விருதுக்காக அளிக்கப்படும் ஒரு லட்சம் ரூபாய் பரிசுத் தொகையை 'சிங்கப்பூர் முஸ்தபா தமிழ் அறக்கட்டளை' வழங்குகிறது.பல்கலைக்கழகங்கள் மற்றும் கல்லூரிகளிலுள்ள ஆய்வுக் கூடங்களிலோ அல்லது அங்கீகரிக் கப்பட்ட வேறு ஆய்வுக்கூடங்களிலோ ஆய்வுகளை மேற்கொள்ளுதல், பெயர் பெற்ற சர்வதேச அறிவியல் இதழ்களில் குறைந்தபட்சம் 10 ஆய்வுக் கட்டுரைகள் வெளிவந்திருத்தல் உள்ளிட்ட சில அடிப்படைத் தகுதிகள் கொண்ட, 40 வயதுக்குட்பட்டவர்கள், தங்களது ஆய்வு விவரக் குறிப்புகளை அனுப்பலாம்.எந்தக் கண்டுபிடிப்புக்கு ஆய்வாளர் விருதுக்குரியவராக விளங்குகிறார் என்பதை சுருக்கமாகவும் தெளிவாகவும் குறிப்பிடுதல் அவசியம். ஆய்வுக் குறிப்புகளையும் ஆய்வு தொடர்பான அனைத்து ஆவணங்களையும் வரும் 25-ம் தேதிக்குள் info@makkalsinthanaiperavai.org என்ற மின்னஞ்சல் முகவரிக்கு அனுப்பி வைக்க வேண்டும்.ஈரோடு புத்தகத் திருவிழாவில், ஆகஸ்ட்5-ம் தேதி மாலை நேர சிந்தனை அரங்க நிகழ்வில் இவ்விருது வழங்கப்படவுள்ளது. விஐடி பல்கலைக்கழக வேந்தர் டாக்டர் ஜி. விஸ்வநாதன் இவ்விருதை வழங்கி விழாச் சிறப்புரையாற்றவுள்ளார் என மக்கள் சிந்தனைப் பேரவை செய்திக்குறிப்பில் தெரிவிக்கப்பட்டுள்ளது.",
      details: [
        { icon: "info", text: "மக்கள் சிந்தனைப் பேரவை வழங்கும் அழைப்பு!" },
        {
          icon: "trophy",
          text: "விருது வழங்கும் நாள்: 05.08.2025 | மாலை 6 மணி"
        },
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிந்தனை அரங்கம், ஈரோடு புத்தகத் திருவிழா வளாகம்"
        },
        {
          icon: "email",
          text: "அனுப்ப வேண்டிய மின்னஞ்சல்: info@makkalsinthanaiperavai.org"
        }
      ],
      mediaType: "text",
      images: []
    },
    {
      title: "அறிவியலுக்காக அர்ப்பணிக்கப்பட்ட ஒரு கனவு",
      description:
        "அறிவியலுக்காக அர்ப்பணிக்கப்பட்ட ஒரு கனவு…ஈரோடு புத்தகத் திருவிழா – 2025மக்கள் சிந்தனைப் பேரவையின் சார்பில் வழங்கப்படும்ஜி.டி. நாயுடு விருது – ரூ.1 லட்சம் பரிசுத்தொகையுடன்தமிழகத்தின் இளமையாரான அறிவியலாளருக்கான மாநிலத்தர சிறப்பு விருது!உங்கள் ஆய்வை உலகறிய செய்யும் அரிய வாய்ப்பு...முற்றிலும் நுண்ணறிவுடனும், உரிமையுடனும் அனுப்புங்கள் உங்கள் ஆய்வுக் குறிப்புகள்.",
      title1:
        "மக்கள் சிந்தனைப் பேரவை சார்பில்சிறந்த இளம் அறிவியலாளர் ஒருவருக்கு ஜி.டி.நாயுடு விருது",
      description1:
        "விருதாளர் 40 வயதிற்கு உட்பட்டவராக இருக்க வேண்டும். புதிய அறிவியல் கண்டுபிடிப்புகளுக்கான ஆய்வு முயற்சிகளில் வெற்றிபெற்றிருக்க வேண்டும். இது மாநிலந்தழுவிய விருது என்பதால் தமிழகத்திலுள்ள அனைத்து மாவட்டங்களைச் சேர்ந்தவர்களும் ஆய்வுக் குறிப்புகளை அனுப்பி வைக்கலாம். இந்தியாவின் வேறு மாநிலங்களில் ஆய்வை மேற்கொள்பவராகவோ, பணிசெய்பவராகவோ உள்ள தமிழ்நாட்டைச் சேர்ந்த அறிவியலாளர்களும் விண்ணப்பிக்கலாம். அறிவியல் துறையில் ஆழத்தடம் பதித்த வல்லுனர்களாக விளங்கும் ஐந்து தகுதி மிக்க அறிவியல் அறிஞர்களின் தலைமையில் ஒரு தேர்வுக்குழு அமைக்கப்பட்டுள்ளது. இக்குழுவினரால் தேர்வு செய்யப்படும் ஒருவருக்கே இவ்விருது வழங்கப்படவுள்ளது இவ்விருது பாராட்டுக் கேடயத்துடன் ரூபாய் ஒரு லட்சம் பரிசுத் தொகையையும் உள்ளடக்கியதாகும். விருதுத் தொகையை எம்.ஏ.முகமது முஸ்தபா அவர்களை நிறுவனராகக் கொண்ட 'சிங்கப்பூர் முஸ்தபா தமிழ் அறக்கட்டளை ' ஒவ்வொரு ஆண்டும் வழங்கி வருகிறது",
      description2:
        "பல்கலைக்கழகங்கள் மற்றும் கல்லூரிகளிலுள்ள ஆய்வுக்கூடங்களிலோ அல்லது அங்கீகரிக்கப்பட்ட வேறு ஆய்வுக்கூடங்களிலோ ஆய்வுகள் மேற்கொள்ளப்பட்டிருக்க வேண்டும். பெயர்பெற்ற சர்வதேச அறிவியல் இதழ்களில் வெளியான தனது 10 கட்டுரைகளின் தலைப்புகளையும் வெளியான இதழ்கள் மற்றும் தேதிகள் குறித்த விவரங்களையும் அனுப்பி வைக்க வேண்டும் எந்தக் கண்டுபிடிப்புக்கு ஆய்வாளர் விருதுக்குரியவராக விளங்குகிறார் என்பதைச் சுருக்கமாகவும் தெளிவாகவும் தெரிவிக்க வேண்டும். ஆய்வுக்குறிப்புகளையும் ஆய்வு தொடர்புள்ள அனைத்து ஆவணங்களையும் எதிர்வரும் 25.07.2025 ஆம் தேதிக்குள் info@makkalsinthanaiperavai.org என்ற மின்னஞ்சல் முகவரிக்கு அனுப்பி வைக்க வேண்டுகிறோம். பலரின் வேண்டுகோளுக்கிணங்க ஏற்கனவே அறிவித்திருந்த கடைசி தேதியிலிருந்து தற்போது கால நீட்டிப்பு செய்யப்பட்டுள்ளது.",
      details: [
        { icon: <FaCalendarAlt />, text: "கடைசி நாள்: 25.07.2025" },
        {
          icon: "trophy",
          text: "விருது வழங்கும் நாள்: 05.08.2025 | மாலை 6 மணி"
        },
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிந்தனை அரங்கம், ஈரோடு புத்தகத் திருவிழா வளாகம்"
        },
        {
          icon: "email",
          text: "அனுப்ப வேண்டிய மின்னஞ்சல்: info@makkalsinthanaiperavai.org"
        }
      ],
      mediaType: "image",
      images: ["/14/14.jpg"]
    },
    {
      title: "கதைக்களம்",
      description: "",
      title1: "",
      description1: "",
      description2: "",
      details: [
        { icon: <FaCalendarAlt />, text: "கடைசி நாள்: 25.07.2025" },
        {
          icon: "trophy",
          text: "விருது வழங்கும் நாள்: 05.08.2025 | மாலை 6 மணி"
        },
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிந்தனை அரங்கம், ஈரோடு புத்தகத் திருவிழா வளாகம்"
        },
        {
          icon: "email",
          text: "அனுப்ப வேண்டிய மின்னஞ்சல்: info@makkalsinthanaiperavai.org"
        }
      ],
      mediaType: "image",
      images: ["/imagesebf/kadhaikalam.jpg"]
    }
  ];

  const otherContentItems = [
    {
      title: "அரசு மேல்நிலைப்பள்ளி சாலைப்புதூர்",
      description:
        "அரசு மேல்நிலைப்பள்ளி சாலைப்புதூர் தலைமை ஆசிரியர் அவர்களிடம் அழைப்பிதழ் வழங்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/1/1.jpg"]
    },
    {
      title: "ராஜேந்திரன் மெட்ரிக் மேல்நிலை பள்ளியில் அழைப்பிதழ்",
      description:
        "ராஜேந்திரன் மெட்ரிக் மேல்நிலை பள்ளியில் அழைப்பிதழ் வழங்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/2/2.jpg"]
    },
    {
      title: "அரசு உயர்நிலைப்பள்ளி வடுகபட்டி அழைப்பிதழ்",
      description:
        "அரசு உயர்நிலைப்பள்ளி வடுகபட்டி அழைப்பிதழ் வழங்கபட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/3/3.jpg"]
    },
    {
      title: "அரசு ஆண்கள் மேல்நிலைப்பள்ளி சிவகிரிதமிழ்நாடு அரசு",
      description:
        "அரசு ஆண்கள் மேல்நிலைப்பள்ளி சிவகிரிதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/4/4.jpg"]
    },
    {
      title: "கொடுமுடி ஒன்றியம் ஆசிரியருக்கு புத்தகத் திருவிழா அழைப்பிதழ்",
      description:
        "கொடுமுடி ஒன்றியம் ஆசிரியருக்கு புத்தகத் திருவிழா அழைப்பிதழ் கொடுக்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/5/5.jpg"]
    },
    {
      title: "தாமரை மெட்ரிக் மேல்நிலைப்பள்ளி, தாமரைபாளையம்",
      description:
        "தாமரை மெட்ரிக் மேல்நிலைப்பள்ளி, தாமரைபாளையம் பள்ளிக்கு ஈரோடு புத்தகத் திருவிழா 2025க்கான அழைப்பிதழ்  வழங்கப்பட்டது!தமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/6/6.jpg"]
    },
    {
      title: "கொடுமுடி ஒன்றியம் ஆசிரியருக்கு புத்தகத் திருவிழா அழைப்பிதழ்",
      description:
        "கொடுமுடி ஒன்றியம் ஆசிரியருக்கு புத்தகத் திருவிழா அழைப்பிதழ் கொடுக்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/7/7-1.jpg", "/7/7-2.jpg", "/7/7-3.jpg"]
    },
    {
      title:
        "தாண்டாம்பாளையம் அரசு மேல்நிலைப்பள்ளி தலைமை ஆசிரியர் அவர்களிடம் புத்தகத் திருவிழா",
      description:
        "தாண்டாம்பாளையம் அரசு மேல்நிலைப்பள்ளி தலைமை ஆசிரியர் அவர்களிடம் புத்தகத் திருவிழா அழைப்பிதழ் வழங்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/8/8-1.jpg", "/8/8-2.jpg"]
    },
    {
      title: "அரசு உயர்நிலை பள்ளி அம்மா பாளையம் தலைமை ஆசிரியர்",
      description:
        "அரசு உயர்நிலை பள்ளி அம்மா பாளையம் தலைமை ஆசிரியர் மற்றும் பெற்றோர் ஆசிரியர் சங்கத்தின் தலைவர் ஆகியோருக்கு ஈரோடு புத்தகத் திருவிழா அழைப்பிதழ் கொடுக்கப்பட்டதுதமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனை பேரவை இணைந்து நடத்தும் 21-ஆம் ஆண்டு ஈரோடு புத்தகத் திருவிழா 2025வாருங்கள், வாசிப்பில் உயர்வோம்!தினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/9/9.jpg"]
    },
    {
      title:
        "(21-07-2025) அரசு மேல்நிலைப்பள்ளி, முகாசி அனுமன்பள்ளியில் (மொடக்குறிச்சி ஒன்றியம்)",
      description:
        "(21-07-2025) அரசு மேல்நிலைப்பள்ளி, முகாசி அனுமன்பள்ளியில் (மொடக்குறிச்சி ஒன்றியம்) தமிழ்நாடு அரசு மற்றும் மக்கள் சிந்தனைப் பேரவை இணைந்து நடத்தும் ஈரோடு புத்தகத் திருவிழாவிற்கான சுவரொட்டிகள்,துண்டறிக்கைகள் மதிப்பிற்குரிய தலைமையாசிரியர் திருமதி.மா.மாதினியாள் அவர்களிடம் வழங்கிய நிகழ்வுதினசரி மாலை 6.00 மணிக்கு அறிஞர்களின் சிறப்புச் சொற்பொழிவு.",
      details: [
        {
          icon: <FaMapMarkerAlt />,
          text: "இடம்: சிக்கய்ய அரசு கலை மற்றும் அறிவியல் கல்லூரி மைதானம், ஈரோடு"
        },
        { icon: <FaCalendarAlt />, text: "தேதி: ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை" },
        { icon: <FaClock />, text: "நேரம்: காலை 11 முதல் இரவு 9.30 வரை" },
        {
          icon: <FaMicrophone />,
          text: "தினமும் மாலை 6 மணிக்கு அறிஞர்களின் சொற்பொழிவு"
        }
      ],
      mediaType: "image",
      images: ["/11/11-1.jpg", "/11/11-2.jpg"]
    },
    {
      title: "அறிவியலுக்காகச் சாதித்த இளம் அறிவியலாளர்களே!",
      description:
        "அறிவியலுக்காகச் சாதித்த இளம் அறிவியலாளர்களே!மாநில அளவில் வழங்கப்படும் ஜி.டி.நாயுடு விருதுக்குஜூலை 25, 2025 தேதிக்குள் விண்ணப்பியுங்கள்.ரூ.1,00,000 பரிசுத்தொகையுடன் அறிவியல் பங்களிப்புக்கு பெருமை சேர்க்கும் தருணம் இது!📍 இடம்: சிந்தனை அரங்கம், ஈரோடு புத்தகத் திருவிழா வளாகம்",
      details: [
        { icon: "info", text: "மக்கள் சிந்தனைப் பேரவை வழங்கும் அழைப்பு!" },
        { icon: <FaCalendarAlt />, text: "கடைசி நாள்: 25.07.2025" },
        {
          icon: "trophy",
          text: "விருது வழங்கும் நாள்: 05.08.2025 | மாலை 6 மணி"
        },
        {
          icon: "email",
          text: "அனுப்ப வேண்டிய மின்னஞ்சல்: info@makkalsinthanaiperavai.org"
        }
      ],
      mediaType: "image",
      images: ["/15/15-1.jpg", "/15/15-2.jpg"]
    }
  ];

  const utpContentItems = {
    tab1: {
      head: "உலகத் தமிழர் படைப்பரங்கம்",
      title:
        "மக்கள் சிந்தனைப் பேரவையின் சார்பில் ஓவிய ஆசிரியர்களுக்கான ஒரு நாள் பயிலரங்கம்",
      description:
        "மக்கள் சிந்தனைப் பேரவையின் சார்பில் ஈரோடு வருவாய் மாவட்டத்திற்குட்பட்ட ஈரோடு, கோபி கல்வி மாவட்டங்களிலுள்ள அரசு மற்றும் தனியார் பள்ளிகளில் ஆசிரியர்களுக்கான ஒருநாள் பயிலரங்கம் புதங்கிழமை நடைபெற்றது. பணியாற்றும் ஓவிய 22.02.2017 ஆம் தேதி ஈரோடு நந்தா பொறியியல் கல்லூரி இப்பயிலரங்கம் காலை மணிவரை நடைபெற்றது. அரங்கில் நடைபெற்ற 9:30 மணிக்குத் தொடங்கி மாலை 6 முன்னதாக நடைபெற்ற பயிலரங்கத் தொடக்க விழாவிற்கு மக்கள் சிந்தனைப் பேரவையின் தலைவர் த.ஸ்டாலின் குணசேகரன் தலைமையேற்றார். ஈரோடு மாவட்டக் கல்வி அலுவலர் மகாராஜன் பயிலரங்கைத் தொடக்கி வைத்தார். நந்தா கல்வி நிறுவனங்களின் தலைவர் வி.சண்முகன் வாழ்த்துரை வழங்கினார். ஓவியர் பயிற்றுனராகப் பயிற்சியளித்தார். மணியம் செல்வன் பங்கேற்று இப்பயிலரங்கில் ஓவிய சிறப்புப் ஆசிரியர்களுக்குப் ஈரோடு மாவட்டம் முழுவதிலிமிருந்து ஆசிரியர்கள் இப்பயிலரங்கில் பங்கேற்றனர். சுமார் 250 ஓவிய நடிகர் சிவகுமார் அவர்கள் வரைந்த ஓவியங்கள் இப்பயிலரங்கை முன்னிட்டு மிக முக்கியமான தனி அரங்கில் சிறப்பு ஏற்பாடுகளுடன் காட்சிக்கு வைக்கப்பட்டிருந்தது. இதனை ஓவிய ஆசிரியர்களும் கல்லூரி மாணவர்களும் பார்வையிட்டனர். பல பயிலரங்க நிறைவில் ஓவியர் மணியம் செல்வன் பயிலரங்கில் பங்கேற்ற ஓவிய ஆசிரியர்கள் அனைவருக்கும் பாராட்டுச் சான்றிதழ் வழங்கினார். இந்நிகழ்வின் தொடக்கத்தில் மக்கள் சிந்தனைப் பேரவையின் செயற்குழு உறுப்பினர் பி.ஆர்.செல்வராஜ் வரவேற்புரையாற்றினார். நிறைவாக மாவட்ட ஓவிய ஆசிரியர்கள் சங்கத் தலைவர் பாரதி நன்றி கூறினார்.",
      images: [
        "https://makalukkaga.mpeoplesnet.com/oviya/1_3.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/2_1.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/3_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/4_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/5_1.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/6_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/7_3.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/8_3.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/9_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/10_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/11_3.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/12_3.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/13_2.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/14_1.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/15_1.jpg",
        "https://makalukkaga.mpeoplesnet.com/oviya/16_1.jpg"
      ]
    },
    tab2: {
      head: "2008",
      title: "உலகத் தமிழர் படைப்பரங்கம்2008 இல் தொடக்கம்",
      description:
        " ஈரோடு புத்தகத் திருவிழாவில் உலகத் தமிழர் படைப்பரங்கம்' என்ற சிறப்பரங்கத் திட்டம் 2008 ஆம் ஆண்டு தொடங்கப்பட்டது.வெளிநாடுகளில் வாழும் தமிழ்ப் படைப்பாளர்களையும் அமைப்புகளையும். வெளியிடும் அயலகத் தமிழ்ப்படைப்பாளிகளின் தமிழகப் பதிப்பாளர்களையும் தமிழ் நூல்களை பேரவையின் சார்பில் தொடர்புகொண்டு அயலகத் தமிழ்ப் படைப்புக்கள் சேகரிக்கப்பட்டன.இவ்வாறு சேகரிக்கப்பட்ட நூல்கள் தமிழ் இலக்கணம், இலக்கியம், வரலாறு. மொழியியல், கவிதை, அறிவியல். மொழிபெயர்ப்பு என்று பல வகைகளைச் சார்ந்தவையாகும்.அதிகப் பிரதிகள் கிடைத்த நூல்களை விற்பனைக்கும் ஒரே ஒரு பிரதி கிடைத்த நூல்கள் பார்வைக்கும் வைக்கப்பட்டன.இச்சிறப்பரங்கத்திற்கு தனி முக்கியத்துவம் கொடுக்கும் வகையில் இவ்வரங்கத்தை சிறப்பு விருந்தினர்களைக் கொண்டு திறந்து வைக்கும் ஏற்பாடுகள் புத்தகத் திருவிழாவின் திறப்பு பிரத்தியேகமாகச் செய்யப்பட்டன விழாவின்போதே01.08.2008 ஆம் தேதி வெள்ளிக்கிழமை காலை 10 மணிக்கு உலகத் தமிழர் படைப்பரங்கத்தை மத்திய ஜவுளித்துறை இணையமைச்சர் மாண்புமிகு ஈவிகே.எஸ்.இளங்கோவன் அவர்கள் திறந்து வைத்தார்.மத்திய சமூகநீதி மற்றும் அதிகாரம் வழங்குதுறை இணையமைச்சர் மாண்புமிகு சுப்புலட்சுமி ஜெகதீசன். தவத்திரு குன்றக்குடி பொன்னம்பல அடிகளார். தமிழகக் கைத்தறி மற்றும் ஜவுளித்துறை அமைச்சர் மாண்புமிகு என்.கே.கே.பி.ராஜா, ஈரோடு மாவட்ட ஆட்சித் தலைவர் திரு மகேசன் காசிராஜன் ஐஏஎஸ் ஆகியோர் முன்னிலை வகித்தனர்.உலகத்தமிழர் படைப்பரங்கம் புத்தகத் திருவிழாவின் முகப்பிலேயே தனிக்கவனமெடுத்து சிறப்பாக அமைக்கப்பட்டிருந்ததால் பல்லாயிரக் கணக்கான வாசகர்களின் தனிக்கவனத்தைப் பெற்றது. ஏராளமான அயலகத் தமிழ்ப் படைப்பாளிகளின் நூல்கள் விற்பனையாகின.",
      images: [
        "https://makalukkaga.mpeoplesnet.com/utp/2008/DSC_0069.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2008/DSC_0075.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2008/utp 2008.jpg"
      ]
    },
    tab3: {
      head: "2014",
      title: "உலகத்தமிழர் படைப்பரங்கம் - 2014",
      description:
        "2008 ஆம் ஆண்டிலிருந்து ஈரோடு புத்தகத் திருவிழாவில் • உலகத் தமிழர் 4 படைப்பரங்கம் என்ற சிறப்பரங்கம் இடம்பெற்று வந்துள்ளது. ஒவ்வொரு ஆண்டும் ஒவ்வொரு விதமாக இச்சிறப்பரங்கம் வடிவமைக்கப்பட்டு வருகிறது.2014 ஆம் ஆண்டின் வித்தியாசமானதாகவும் உலகத்தமிழர் படைப்பரங்கம் மிகவும் முக்கியத்துவம் அமைக்கப்பட பேரவையால் முடிவெடுக்கப்பட்டது. சங்கள் இந்த ஆண்டு அறிமுகப்படுத்தப்பட்டன. முற்றிலும் பெற்றதாகவும் பல புதிய சிறப்பம்அயல்நாடுகளில் மிகச்சிறந்த தமிழ்ப் பணியாற்றிய ஒரு ஆளுமையின் பெயரை இவ்வரங்கத்திற்குச் சூட்டுவதென தீர்மானிக்கப்பட்டது. அத்தோடு அடுத்தடுத்த ஆண்டுகளில் சுழற்சி முறையில் வெவ்வேறு அயலகத் தமிழறிஞர்களின் பெயர்களைச் சூட்டுவதெனவும் முடிவெடுக்கப்பட்டது.படைப்பரங்கத்திற்கு அயலகத் தமிழறிஞர்களின் பெயர் முடிவெடுக்கப்பட்ட முதல் ஆண்டாம் 2014 இல் சிங்கப்பூர்த் தலைவரும். சிங்கப்பூர் தமிழ் முரசு சூட்ட தமிழர் இதழின் ஆசிரியரும் தந்தை பெரியாரை இரண்டு முறை சிங்கப்பூரில் வரவேற்று உபசரித்ததோடு அவருக்கு பல கூட்டங்களை சிங்கப்பூரில் ஏற்பாடு செய்தவரும் சிங்கப்பூரில் தமிழ் அதிகாரத்துவ மொழிகளில் ஒன்றாக தேர்வுசெய்யப்பட முக்கியக் காரணமாக விளங்கியவர்களில் ஒருவருமான தமிழவேள் கோ. சாரங்கபாணி அவர்களின் பெயர் சூட்டப்பட்டது.01.08.2014 ஆம் தேதி வெள்ளிக்கிழமை மாலை 6 மணிக்கு பத்தாம் ஆண்டு ஈரோடு புத்தகத் திருவிழாவைத் திறந்துவைத்த இசைஞானி இளையராஜா அவர்களே உலகத்தமிழர் படைப்பரங்கத்தையும் திறந்துவைத்தார்.சிங்கப்பூர் எழுத்தாளர் கிருத்திகா எழுதிய என்ற நூல் படைப்பாளர் அரங்கத்தில் உல்லாசக் கப்பல் பயணம் 02.08.2014 ஆம் தேதி வெளியிடப்பட்டது. நூலாசிரியர் திருமதி கிருத்திகா அவர்கள் அவரின்",
      description1:
        "நூல் உருவாக்கம் பற்றியும் பொதுவாக சிங்கப்பூர்த் தமிழ்ப் படைப்புகள் குறித்தும் உரைநிகழ்த்தினார்.04.08.2014 ஆம் தேதி படைப்பாளர் அரங்கத்தில் சிங்கப்பூர் முஸ்தபா தமிழ் அறக்கட்டளையின் தலைவர் திரு எம். ஏ. முஸ்தபா அவர்கள் உரைநிகழ்த்தினார். இவரது சிற்றுரைக்குப் பிறகு கேள்வி - பதில் வடிவில் நீண்ட நேரம் கலந்துரையாடல் நடைபெற்றது. பார்வையாளர்களின் பலவிதமான கேள்விகளுக்கு நுட்பமான பதிலளித்தார் திரு எம்.ஏ. முஸ்தபா அவர்கள்.09.08.2014 ஆம் தேதி சிங்கப்பூர்த் தமிழ் எழுத்தாளர் கழகத்தின் தலைவர் திரு நா. ஆண்டியப்பன் அவர்கள் எழுதிய மீசைமுளைக்காத காதல் என்ற கவிதை நூலை கல்வெட்டறிஞர் முனைவர் செ. இராசு அவர்கள் வெளியிட பாவலர் இறையரசன் அவர்கள் முதல் பிரதியைப் பெற்றுக் கொண்டார்.இந்நிகழ்வில் சிங்கப்பூர் கவிஞர் இறை. மதியழகன் அவர்களும் சிங்கப்பூர் மக்கள் கவிஞர் மன்றத் தலைவர் திரு வீ ராமசாமி அவர்களும் உரை நிகழ்த்தினர்.",
      images: [
        "https://makalukkaga.mpeoplesnet.com/utp/2014/1.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/2.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/4.jpg",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/5.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/6.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/7.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/8.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/9.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/10.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/11.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/12.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/13.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/14.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/15.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/16.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/17.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/18.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/19.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/20.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/21.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/22.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/23.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/24.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/25.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/26.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2014/27.JPG"
      ]
    },
    tab4: {
      head: "2015",
      title: "உலகத் தமிழர் படைப்பரங்கம் - 2015",
      description:
        "2015 ஆம் ஆண்டின் உலகத்தமிழர் படைப்பரங்கத்தை 31.07.2015 ஆம் தேதி வெள்ளிக்கிழமை மாலை 6 மணிக்கு மலேசிய நாட்டின் தமிழர் தலைவரும் பல்லாண்டுகள் மலேசியாவின் அமைச்சராகத் திகழ்ந்தவரும் தற்போது இந்திய தெற்காசிய கட்டமைப்புகளுக்கான மலேசிய நாட்டின் தூதருமான டத்தோஸ்ரீ உத்தாமா ச.சாமிவேலு அவர்கள் திறந்து வைத்தார். சென்னை உயர்நீதிமன்ற முன்னாள் நீதிபதி மாண்பமை கே.சந்துரு அவர்கள் முன்னிலை வகித்தார்.2008 ஆம் ஆண்டில் தொடங்கப்பட்ட உலகத் தமிழர் படைப்பரங்கம் படிப்படியாக செழுமைப்படுத்தப்பட்டு 2015 இல் அதன் அடுத்த கட்டத்தை அடைந்தது.இந்த ஆண்டின் உலகத்தமிழர் படைப்பரங்கத்திற்கு இலங்கை யாழ்பாணப் பல்கலைக்கழகத்தின் முன்னாள் தமிழ்த்துறைத் தலைவரும் உலகறிந்த திறனாய்வாளரும் தமிழர் வரலாற்று ஆய்வாளருமான இலங்கைத் தமிழறிஞர் பேராசிரியர் கலாநிதி க.கைலாசபதி அவர்களின் பெயர் சூட்டப்பட்டது.உலகெங்கிலுமுள்ள ஆண்டுமுழுக்க தமிழ்ப் முயற்சியெடுத்து படைப்பாளிகளின் ஏராளமாகத் நூல்கள் திரட்டப்பட்டு இச்சிறப்பரங்கில் விற்பனைக்காக வைக்கப்பட்டன. மக்களின் கவனத்தை இச்சிறப்பரங்கத்தை நோக்கித் திருப்புவதற்குப் L2 வித்தியாசமான முயற்சிகளும் மேற்கொள்ளப்பட்டன.அரங்கத்தின் அளவை மேலும் பெரிதாக்கி ஓரளவு விசாலப்படுத்தி வெளிநாட்டிலிருந்து வரவழைக்கப்பட்ட தமிழ்ப்படைப்பாளிகள். தமிழ் அமைப்புகளின் பிரதிநிதிகள் உரை நிகழ்த்தும் விதத்தில் கூடுதலான முயற்சிகள் எடுக்கப்பட்டன.05.08.2015 ஆம் தேதி புதன்கிழமை காலை 11 மணிக்கு அமெரிக்கத் தமிழ்க் கல்விக் கழகத்தின் இயக்குனர் அமெரிக்கவாழ் தமிழர் திரு இரா",
      description1:
        "பொற்செழியன் அவர்கள் 'அமெரிக்காவில் தமிழ்ச் சூழல் என்ற தலைப்பில் சிறப்புச் சொற்பொழிவாற்றினார்.06.08 2015 ஆம் தேதி வியாழக்கிழமை காலை 11 மணிக்கு உலகத் தமிழ்மொழி அறக்கட்டளையின் இயக்குனர் அமெரிக்கவாழ் தமிழர் திரு அழகப்பா ராம்மோகன் அவர்கள் தமிழரின் அடையாளம்' என்ற தலைப்பில் திருக்குறளை உலகெங்கும் எடுத்துச் செல்ல வேண்டியதன் அவசியம் குறித்து நுட்பமாகவும் ஆழமாகவும் உரை நிகழ்த்தினார்.07.08.2015 ஆம் தேதி வெள்ளிக்கிழமை காலை 11 மணிக்கு லண்டனிலிருந்து வருகைபுரிந்த இலக்கிய ஆர்வலரும் எழுத்தாளர் ஜெயகாந்தன் நூலை சமீபத்தில் வித்தியாசமாகப் பதிபித்து ஜெயகாந்தன் முன்னிலையிலேயே வெளியிட்டவருமான இங்கிலாந்துவாழ் தமிழர் டாக்டர் என்.ராம் அவர்கள் பழந்தமிழ்ப் படைப்புக்களைப் பாதுகாப்போம்' என்ற தலைப்பில் உரை நிகழ்த்தினார்.அதே 07.08.2015 ஆம் தேதி மதியம் 02.30 மணிக்கு நடைபெற்ற நிகழ்வில் சிங்கப்பூர் தமிழ் இலக்கியக் களத்தின் துணைத்தலைவர் கவிஞர் இறை மதியழகன் அவர்கள் வெள்ளிவிழா நாடும் நாயகரும் என்ற தலைப்பில் சிங்கப்பூரைப் பற்றியும் சிங்கப்பூரில் தமிழர் நிலை குறித்தும் சிங்கப்பூரின் நாயகராம் லீ குவான் யூ அவர்கள் தமிழர்கள் மீது வைத்திருந்த நம்பிக்கை குறித்தும் உரையாற்றினார்.சிங்கைத் தமிழ் அமைப்புகளும் தொடர்புகளும்' என்ற தலைப்பில் சிங்கப்பூர் கவிமாலை: அமைப்பின் துணைச் செயலாளர் கவிஞர் தியாக இரமேஷ் அவர்கள் உரை நிகழ்த்தினார்.வெளிநாடுவாழ் உரைநிகழ்த்திய தமிழர்களான பின்னர் இச்சிறப்பு பார்வையாளர்களின் விடையளிக்கும் கலந்துரையாடல் நிகழ்வு நடைபெற்றது. விருந்தினர்கள் கேள்விகளுக்குஇந்நிகழ்ச்சிகளையும் விருந்தினர்களையும் மக்கள் அழைக்கப்பட்டிருந்த சிந்தனைப் பேரவையின் சிறப்பு தலைவர் த ஸ்டாலின் குணசேகரன் அறிமுகப்படுத்திப் பேசியதோடு நிகழ்ச்சியை ஒருங்கிணைத்தார்.",
      images: [
        "https://makalukkaga.mpeoplesnet.com/utp/2015/1.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/2.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/3.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/4.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/5.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/6.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/7.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/8.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/9.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/10.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/11.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/12.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/13.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/14.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/15.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/16.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/17.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/18.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/19.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/20.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/21.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/22.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/23.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/24.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/25.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/26.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/27.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/28.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/29.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/30.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/31.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2015/32.JPG"
      ]
    },
    tab5: {
      head: "2016",
      title: "உலகத்தமிழர் படைப்பரங்கம் 2016",
      description:
        "ஈரோடு புத்தகத் திருவிழாவில் அமையப்பெற்ற 2016 ஆம் ஆண்டின் உலகத்தமிழர் படைப்பரங்கத்திற்கு இலங்கைத் தமிழறிஞர் ஆறுமுக நாவலர் அவர்களின் பெயர் சூட்டப்பட்டது.இந்த ஆண்டின் உலகத்தமிழர் படைப்பரங்கத்தை தேதி வெள்ளிக்கிழமை மாலை 6 மணிக்கு 05.08.2016 ஆம் உலகத்தமிழர் பேரமைப்பின் தலைவர் திரு பழ. நெடுமாறன் அவர்கள் திறந்து வைத்தார். சென்னை மற்றும் காமராசர் பல்கலைக்கழகங்களின் முன்னாள் துணைவேந்தர் முனைவர் தென்னிந்திய புத்தக விற்பனையாளர் சங்கத்தலைவர் திரு காந்தி ப.க. மற்றும் கண்ணதாசன். பண்ணாரி அம்மன் தொழிநுட்பக் கல்லூரியின் பொன்னுசாமி, பதிப்பாளர்கள் சத்தியமங்கலம் தலைவர் திரு எஸ்.வி. பாலசுப்பிரமணியம் ஆகியோர் முன்னிலை வகித்தனர்.14.08.2016 ஆம் தேதி ஞாயிற்றுக்கிழமை கால்ை 11 நடைபெற்ற படைப்பரங்க சிறப்பு நிகழ்ச்சியில் சிங்கப்பூர் நிலா மணிக்கு புதிய மாத இதழின் ஆசிரியர் கவிஞர் பிச்சினிக்காடு இளங்கோ அவர்கள் கவிதையும் நானும் என்ற தலைப்பில் உரையாற்றினார். சிங்கப்பூர் 4 கவிமாலை அமைப்பின் தலைவர் கவிஞர் இறை. மதியழகன் அவர்கள் கவிதை ரசனை நிகழ்த்தினார். என்ற தலைப்பில் உரைசென்ற ஆண்டு வரவழைக்கப்பட்ட அயலகத் தமிழ்ப் படைப்புக்களைவிட அதிக எண்ணிக்கையிலான புதிய தலைப்பு நூல்கள் இந்த ஆண்டு பேரவையால் மேற்கொள்ளப்பட்டு வரவழைக்கப்பட்டன. சிறப்பு முயற்சிகள்பொதுமக்களுக்கு வலுவான முறையில் இப்படைப்பரங்கம் குறித்த செய்திகள் சென்றடைந்துள்ளன என்பதை அதிக எண்ணிக்கையிலான வாசகர் வருகை உறுதிப்படுத்தியுள்ளது.இந்த ஆண்டின் ஈரோடு புத்தகத் திருவிழாவிற்கு 60 க்கும் மேற்பட்ட அயலகத் தமிழ் ஆளுமைகள் வருகைபுரிந்தனர். அவர்களின் வருகைக்கான ஈர்ப்புமையமாக உலகத்தமிழர் படைப்பரங்கம் விளங்கியது.",
      images: [
        "https://makalukkaga.mpeoplesnet.com/utp/2016/001.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/002.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/003.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/004.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/005.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/006.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/0006.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/007.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/008.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/009.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/0010.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/011.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/012.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/013.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/014.JPG",
        "https://makalukkaga.mpeoplesnet.com/utp/2016/015.JPG"
      ]
    },
    tab6: {
      head: "2017",
      title: "",
      description: "",
      images: [
        "https://makalukkaga.mpeoplesnet.com/utp/2017/N5.jpg",
        "https://makalukkaga.mpeoplesnet.com/utp/2017/N6.jpg"
      ]
    }
  };

  const getGridClass = (count) => {
    switch (count) {
      case 2:
        return "two-images";
      case 3:
        return "three-images";
      case 4:
        return "four-images";
      default:
        return "";
    }
  };

  const handleVideoPlay = (index) => {
    setActiveVideo(index);
  };

  const handleVideoPause = () => {
    setActiveVideo(null);
  };

  const isOtherContentTab = activeTab === mainContentItems.length;
  const isUtpContentTab = activeTab === mainContentItems.length + 1;

  const highlightsData = {
    2024: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2024",
      type: "image-carousel",
      content: {
        images: [
          {
            src: "/sirappuamsam/2024/1.jpg",
            alt: "20241",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/2.jpg",
            alt: "20242",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/3.jpg",
            alt: "20243",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/4.jpg",
            alt: "20241",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/5.jpg",
            alt: "20242",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/6.jpg",
            alt: "20243",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/7.jpg",
            alt: "20241",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/8.jpg",
            alt: "20242",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/9.jpg",
            alt: "20243",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/10.jpg",
            alt: "20241",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/11.jpg",
            alt: "20242",
            caption: ""
          },
          {
            src: "/sirappuamsam/2024/12.jpg",
            alt: "20243",
            caption: ""
          }
        ]
      }
    },
    2023: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2023",
      type: "image-carousel",
      content: {
        images: [
          {
            src: "/sirappuamsam/2023/1.jpg",
            alt: "20231",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/2.jpg",
            alt: "20232",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/3.jpg",
            alt: "20233",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/4.jpg",
            alt: "20231",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/5.jpg",
            alt: "20232",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/6.jpg",
            alt: "20233",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/7.jpg",
            alt: "20231",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/8.jpg",
            alt: "20232",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/9.jpg",
            alt: "20233",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/10.jpg",
            alt: "20231",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/11.jpg",
            alt: "20232",
            caption: ""
          },
          {
            src: "/sirappuamsam/2023/12.jpg",
            alt: "20233",
            caption: ""
          }
        ]
      }
    },
    2022: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2022",
      type: "image-carousel",
      content: {
        images: [
          {
            src: "/sirappuamsam/2022/1.jpg",
            alt: "20221",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/2.jpg",
            alt: "20222",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/3.jpg",
            alt: "20223",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/4.jpg",
            alt: "20221",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/5.jpg",
            alt: "20222",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/6.jpg",
            alt: "20223",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/7.jpg",
            alt: "20221",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/8.jpg",
            alt: "20222",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/9.jpg",
            alt: "20223",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/10.jpg",
            alt: "20221",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/11.jpg",
            alt: "20222",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/12.jpg",
            alt: "20223",
            caption: ""
          },
          {
            src: "/sirappuamsam/2022/மக்கள் சிந்தனைப் பேரவையின் நன்றி.jpeg",
            alt: "20223",
            caption: ""
          }
        ]
      }
    },
    2021: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2021",
      type: "table",
      content: {
        headers: ["நாள்", "சொற்பொழிவாளர்", "தலைப்பு"],
        rows: [
          [
            "30.07.2021 வெள்ளி",
            "குன்றக்குடி பொன்னம்பல அடிகளார்",
            "மண்ணில் நல்ல வண்ணம் வாழலாம்"
          ],
          [
            "31.07.2021 சனி",
            "கவிஞர் மரபின்மைந்தன் முத்தையா",
            "அருகே இருந்த அபூர்வங்கள்"
          ],
          ["01.08.2021 ஞாயிறு", "திருமதி கவிதா ஜவகர்", "மாதா பிதா புத்தகம்"],
          [
            "02.08.2021 திங்கள்",
            "கம்பவாரிதி இலங்கை ஜெயராஜ்",
            "மருந்தென வேண்டாவாம் யாக்கைக்கு"
          ],
          ["03.08.2021 செவ்வாய்", "கவிஞர் நந்தலாலா", "காவிரியும் கரிசலும்"],
          [
            "04.08.2021 புதன்",
            "பேராசிரியர் கு.ஞானசம்பந்தன்",
            "கற்றலைப் போற்றுவோம்"
          ],
          ["05.08.2021 வியாழன்", "பேராசிரியர் சுப.வீரபாண்டியன்", "எழுத்து"],
          [
            "06.08.2021 வெள்ளி",
            "எழுத்தாளர் பவா செல்லதுரை",
            "மண்ணை மீறும் விதைகள்"
          ],
          [
            "07.08.2021 சனி",
            "கவிஞர் ஆண்டாள் பிரியதர்ஷினி",
            "ஃபீனிக்ஸ் பெண்கள்"
          ],
          [
            "08.08.2021 ஞாயிறு",
            "வழக்கறிஞர் த.இராமலிங்கம்",
            "நீதி நூறு சொல்லுவாய்"
          ],
          ["9.08.2021 திங்கள்", "மருத்துவர் கு.சிவராமன்", "ஒரே நலம்"],
          ["10.08.2021 செவ்வாய்", "எழுத்தாளர் வாஸந்தி", "எழுத்தும் பயணமும்"]
        ]
      }
    },
    2020: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2020",
      type: "table",
      content: {
        headers: ["நாள்", "சொற்பொழிவாளர்", "தலைப்பு"],
        rows: [
          [
            "31.07.2020 வெள்ளி",
            "கவிப்பேரரசு வைரமுத்து",
            "இலக்கியத்தில் நாகரிகம்"
          ],
          [
            "01.08.2020 சனி",
            "பாரதி கிருஷ்ணகுமார்",
            "அறிவினைத் தூண்டி நடத்துக!"
          ],
          [
            "02.08.2020 ஞாயிறு",
            "த. உதயச்சந்திரன் ஐ.ஏ.எஸ்.,",
            "அகழ்வாரைத் தேடும் நிலம்"
          ],
          [
            "03.08.2020 திங்கள்",
            "பேராசிரியர் சிற்பி பாலசுப்பிரமணியம்",
            "காலவெளியில் ஒரு ஜீவநதி"
          ],
          [
            "04.08.2020 செவ்வாய்",
            "பேராசிரியர் த. ராஜாராம்",
            "விசும்பின் துளியாய்..."
          ],
          [
            "05.08.2020 புதன்",
            "பேராசிரியர் தி.மு. அப்துல்காதர்",
            "ஆறாவது விரல்"
          ],
          [
            "06.08.2020 வியாழன்",
            "சொல்வேந்தர் சுகி. சிவம்",
            "நம் வாழ்க்கை நம் கையில்"
          ],
          [
            "07.08.2020 வெள்ளி",
            "முனைவர் வெ. இறையன்பு ஐ.ஏ.எஸ்",
            "பயணங்கள் முடிவதில்லை"
          ],
          ["08.08.2020 சனி", "பேராசிரியர் ஜெயந்தஸ்ரீ பாலகிருஷ்ணன்", "நூலேணி"],
          [
            "09.08.2020 ஞாயிறு",
            "நீதிபதி ஆர்.மகாதேவன்",
            "அறம் பொருள் இன்பம் அகிலமே சூழ்க..."
          ],
          [
            "10.08.2020 திங்கள்",
            "விஞ்ஞானி மயில்சாமி அண்ணாதுரை",
            "சவால்களும் சந்தர்ப்பங்களும்"
          ],
          [
            "11.08.2020 செவ்வாய்",
            "பேராசிரியர் சாலமன் பாப்பையா",
            "சங்கத்தமிழ்ச் சிந்தனைகள்"
          ]
        ]
      }
    },
    2019: {
      title: "",
      type: "pdf",
      content: {
        file: "/sirappuamsam/2019.pdf",
        description: "2019 ஆம் ஆண்டு புத்தகத் திருவிழா"
      }
    },
    2018: {
      title: "ஈரோடு புத்தகத் திருவிழா - 2018",
      type: "table",
      content: {
        headers: ["நாள்", "சொற்பொழிவாளர்", "தலைப்பு"],
        rows: [
          ["03.08.2018 வெள்ளிக்கிழமை", "கவிப்பேரரசு வைரமுத்து", "தொடக்கவிழா"],
          ["04.08.2018 சனிக்கிழமை", "சுகி.சிவம்", "நம் வாழ்க்கை நம் கையில்"],
          [
            "05.08.2018 ஞாயிற்றுக்கிழமை",
            "ஆண்டாள் பிரியதர்ஷினி",
            "கண்ணதாசன் என்னும் கடல்"
          ],
          [
            "06.08.2018 திங்கள்கிழமை",
            "பட்டிமன்றம் இலங்கை ஜெயராஜ்",
            "இலக்கியத்தின் மூலநோக்கம் மக்களை மகிழ்விப்பதே | மானுடத்தை உய்விப்பதே"
          ],
          [
            "07.08.2018 செவ்வாய்க்கிழமை",
            "ஜெயந்தஸ்ரீ பாலகிருஷ்ணன்",
            "ஆலந்தோப்பு"
          ],
          [
            "08.08.2018 புதன்கிழமை",
            "மூத்த இதழாளர்கள் பங்கேற்கும் நிகழ்ச்சி திருப்பூர் கிருஷ்ணன், மூலிகைமணிவேங்கடேசன்,ஏர்வாடி எஸ்.இராதாகிருஷ்ணன்",
            ""
          ],
          [
            "09.08.2018 வியாழக்கிழமை",
            "எல் வாசுகி மனோகரன் + மூன்று இளம் பேச்சாளர்கள்",
            ""
          ],
          [
            "10.08.2018 வெள்ளிக்கிழமை",
            "கி. வீரமணி",
            "புத்தகப் புரட்சி அன்றும் இன்றும்..."
          ],
          ["11.08.2018 சனிக்கிழமை", "நர்த்தகி நடராஜ்", ""],
          [
            "12.08.2018 ஞாயிற்றுக்கிழமை",
            "நடிகர் சிவகுமார்",
            "சிவாஜி ஒரு சகாப்தம்"
          ],
          [
            "13.08.2018 திங்கள்கிழமை",
            "நடிகர் சத்யராஜ் & நடிகர் பார்த்திபன்",
            "என் கேரக்டரையே புரிஞ்சிக்க மாட்டிங்கிறீங்களே !"
          ],
          ["14.08.2018 செவ்வாய்க்கிழமை", "துளசி ஐயா வாண்டையார்", "நிறைவு விழா"]
        ]
      }
    }
  };

  const [displayContent, setDisplayContent] = useState(highlightsData["2018"]);

  const handleTabChange = (year) => {
    if (activeTab1 !== year && !isTransitioning) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveTab1(year);
        setDisplayContent(highlightsData[year]);
        setIsTransitioning(false);
      }, 300);
    }
  };

  const nextImage = () => {
    setCurrentImageIndex(
      (prevIndex) => (prevIndex + 1) % displayContent.content.images.length
    );
  };

  const prevImage = () => {
    setCurrentImageIndex(
      (prevIndex) =>
        (prevIndex - 1 + displayContent.content.images.length) %
        displayContent.content.images.length
    );
  };

  const renderContent = () => {
    switch (displayContent.type) {
      case "text":
        return (
          <div className="highlights-list">
            <ul>
              {displayContent.content.items.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        );
      case "pdf":
        return (
          <div className="pdf-viewer-container">
            <p className="pdf-description">
              {displayContent.content.description}
            </p>
            <div className="pdf-iframe-container">
              <iframe
                src={`${displayContent.content.file}#toolbar=0&navpanes=0`}
                title={displayContent.title}
                width="100%"
                height="600px"
                style={{ border: "none" }}
              >
                <p>
                  உங்கள் உலாவி PDF கோப்புகளை ஆதரிக்கவில்லை.
                  <a href={displayContent.content.file}>PDF ஐப் பதிவிறக்குக</a>
                </p>
              </iframe>
            </div>
            <div className="pdf-download">
              <a
                href={displayContent.content.file}
                download
                className="download-button"
              >
                PDF ஐ பதிவிறக்குக
              </a>
            </div>
          </div>
        );
      case "table":
        return (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  {displayContent.content.headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {displayContent.content.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, cellIndex) => (
                      <td key={cellIndex}>{cell}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      case "image-carousel":
        return (
          <div className="carousel-container">
            <div className="carousel">
              <button className="carousel-button prev" onClick={prevImage}>
                &#10094;
              </button>

              <div
                className="carousel-slide"
                onClick={() =>
                  openImageModal(
                    displayContent.content.images[currentImageIndex].src
                  )
                }
              >
                <img
                  src={displayContent.content.images[currentImageIndex].src}
                  alt={displayContent.content.images[currentImageIndex].alt}
                />
                <p className="image-caption">
                  {displayContent.content.images[currentImageIndex].caption}
                </p>
              </div>

              <button className="carousel-button next" onClick={nextImage}>
                &#10095;
              </button>
            </div>
            <div className="carousel-indicators">
              {displayContent.content.images.map((_, index) => (
                <span
                  key={index}
                  className={`indicator ${
                    index === currentImageIndex ? "active" : ""
                  }`}
                  onClick={() => setCurrentImageIndex(index)}
                ></span>
              ))}
            </div>
          </div>
        );
      case "mixed":
        return (
          <div className="mixed-content">
            <div className="text-content">
              {displayContent.content.text.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <div className="image-content">
              {displayContent.content.images.map((image, index) => (
                <div key={index} className="mixed-image">
                  <img src={image.src} alt={image.alt} />
                  <p className="image-caption">{image.caption}</p>
                </div>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="content-container">
        {/* Tabs Navigation */}
        <div className="tabs-containerpost">
          <div className="tabs-scrollpost">
            {mainContentItems.map((item, index) => (
              <button
                key={index}
                className={`tab-buttonpost ${
                  activeTab === index ? "active" : ""
                }`}
                onClick={() => setActiveTab(index)}
              >
                {item.title.length > 30
                  ? `${item.title.substring(0, 30)}...`
                  : item.title}
              </button>
            ))}
            <button
              className={`tab-buttonpost ${isUtpContentTab ? "active" : ""}`}
              onClick={() => setActiveTab(mainContentItems.length + 1)}
            >
              உலகத் தமிழர் படைப்பரங்கம்
            </button>
            <button
              className={`tab-buttonpost ${isOtherContentTab ? "active" : ""}`}
              onClick={() => setActiveTab(mainContentItems.length)}
            >
              பள்ளி அழைப்பிதழ்கள்
            </button>
          </div>
        </div>

        {/* Active Tab Content */}
        <div className="tab-contentpost">
          {isOtherContentTab ? (
            <div className="other-content-grid">
              {otherContentItems.map((item, index) => (
                <div key={index} className="other-content-card">
                  <div className="content-textpost">
                    <h2 className="tamil-headingpost">{item.title}</h2>
                    <p className="tamil-textpost">{item.description}</p>

                    <div className="media-containerpost">
                      {item.mediaType === "image" && (
                        <div
                          className={`image-gridpost ${getGridClass(
                            item.images.length
                          )}`}
                        >
                          {item.images.map((image, imgIndex) => (
                            <div key={imgIndex} className="image-containerpost">
                              <img
                                src={image}
                                alt={`${item.title} ${imgIndex + 1}`}
                                className="content-imagepost"
                                onClick={() => setSelectedImage(image)}
                              />
                              <div
                                className="image-overlaypost"
                                onClick={() => setSelectedImage(image)}
                              >
                                <span className="zoom-iconpost">🔍</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : isUtpContentTab ? (
            <div className="utp-content-container">
              {Object.entries(utpContentItems).map(([key, item]) => (
                <div key={key} className="utp-content-card">
                  <h2 className="utp-head">{item.head}</h2>
                  {item.title && <h3 className="utp-title">{item.title}</h3>}
                  {item.description && (
                    <p className="utp-description">{item.description}</p>
                  )}
                  {item.description1 && (
                    <p className="utp-description">{item.description1}</p>
                  )}

                  {item.images.length > 0 && (
                    <div
                      className={`image-gridpost ${getGridClass(
                        item.images.length
                      )}`}
                    >
                      {item.images.map((image, imgIndex) => (
                        <div key={imgIndex} className="image-containerpost">
                          <img
                            src={image}
                            alt={`${item.head} ${imgIndex + 1}`}
                            className="content-imagepost"
                            onClick={() => setSelectedImage(image)}
                          />
                          <div
                            className="image-overlaypost"
                            onClick={() => setSelectedImage(image)}
                          >
                            <span className="zoom-iconpost">🔍</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="content-cardpost">
              {mainContentItems[activeTab].title === "கதைக்களம்" ? (
                <div className="responsive-table-container">
                  <div className="table-scroll-wrapper">
                    <table>
                      <thead>
                        <tr>
                          <th>தேதி</th>
                          <th>சிறப்பு விருந்தினர்</th>
                          <th>தலைப்பு</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>02.08.25</td>
                          <td>
                            {" "}
                            <strong> சி. வனிதாமணி அருள்வேல் </strong> நிறுவனர் -
                            கதைக்களம், <br /> The Storytelling Academy{" "}
                            <strong> மதியம்: கோதை </strong> கதைசொல்லி
                          </td>
                          <td>கதைப்போமா?</td>
                        </tr>
                        <tr>
                          <td>04.08.25</td>
                          <td>
                            {" "}
                            <strong> லெட்சுமி விசாகன் </strong> <br /> கதைசொல்லி
                          </td>
                          <td>கற்பனைக்குள் கை கோர்க்கலாம்..</td>
                        </tr>
                        <tr>
                          <td>05.08.25</td>
                          <td>
                            <strong>சரிதா ஜோ</strong> <br /> கதைசொல்லி,
                            எழுத்தாளர்
                          </td>
                          <td>வாங்க! கதை கதையாய் கதைப்போம்!</td>
                        </tr>
                        <tr>
                          <td>06.08.25</td>
                          <td>
                            {" "}
                            <strong> நான்சி கோமகன் </strong> <br /> ஆசிரியர்.
                            கதைசொல்லி எழுத்தாளர்
                          </td>
                          <td>ஓகோ! அப்படியா?|</td>
                        </tr>
                        <tr>
                          <td>07.08.25</td>
                          <td>
                            {" "}
                            <strong> சங்கீதா பிரகாஷ் </strong> <br /> கதை
                            சொல்லி, ஊக்க உரையாளர்
                          </td>
                          <td>கற்பனைக்குள்..</td>
                        </tr>
                        <tr>
                          <td>08.08.25</td>
                          <td>
                            <strong> ஈரோடு சர்மிளா </strong> <br /> பேராசிரியர்,
                            எழுத்தாளர், பேச்சாளர்,கதைசொல்லி
                          </td>
                          <td>ஒரு ஊர்ல..</td>
                        </tr>
                        <tr>
                          <td>07.08.25</td>
                          <td>
                            {" "}
                            <strong> சங்கீதா பிரகாஷ் </strong> <br /> கதை
                            சொல்லி, ஊக்க உரையாளர்
                          </td>
                          <td>கற்பனைக்குள்..</td>
                        </tr>
                        <tr>
                          <td>09.08.25</td>
                          <td>
                            {" "}
                            <strong>
                              {" "}
                              கார்த்திகா கவின் குமார்{" "}
                            </strong> <br /> எழுத்தாளர்
                          </td>
                          <td>கதைகளின் உலகம்,</td>
                        </tr>
                        <tr>
                          <td>11.08.25</td>
                          <td>
                            {" "}
                            <strong>தீரா தேன்மொழி</strong> <br /> ஆசிரியர்
                          </td>
                          <td>கதைகளின் மாயாஜாலம்,</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                // Regular content for other tabs
                <>
                  <div className="content-textpost">
                    <h2 className="tamil-headingpost">
                      {mainContentItems[activeTab].title}
                    </h2>
                    <p className="tamil-textpost">
                      {mainContentItems[activeTab].description}
                    </p>
                    <h2 className="tamil-headingpost">
                      {mainContentItems[activeTab].title1}
                    </h2>
                    <p className="tamil-textpost">
                      {mainContentItems[activeTab].description1}
                    </p>
                    <p className="tamil-textpost">
                      {mainContentItems[activeTab].description2}
                    </p>

                    <div className="media-containerpost">
                      {mainContentItems[activeTab].mediaType === "video" ? (
                        <div
                          className={`video-wrapperpost ${
                            activeVideo === activeTab ? "active" : ""
                          }`}
                        >
                          <video
                            controls
                            className="content-videopost"
                            onPlay={() => handleVideoPlay(activeTab)}
                            onPause={handleVideoPause}
                          >
                            <source
                              src={mainContentItems[activeTab].videos[0]}
                              type="video/mp4"
                            />
                            உங்கள் உலாவி வீடியோவை ஆதரிக்கவில்லை
                          </video>
                        </div>
                      ) : mainContentItems[activeTab].mediaType === "image" ? (
                        <div
                          className={`image-gridpost ${getGridClass(
                            mainContentItems[activeTab].images.length
                          )}`}
                        >
                          {mainContentItems[activeTab].images.map(
                            (image, imgIndex) => (
                              <div
                                key={imgIndex}
                                className="image-containerpost"
                              >
                                <img
                                  src={image}
                                  alt={`${mainContentItems[activeTab].title} ${
                                    imgIndex + 1
                                  }`}
                                  className="content-imagepost"
                                  onClick={() => setSelectedImage(image)}
                                />
                                <div
                                  className="image-overlaypost"
                                  onClick={() => setSelectedImage(image)}
                                >
                                  <span className="zoom-iconpost">🔍</span>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* Details Section */}
                  <div className="details-section">
                    <h3 className="details-heading">விவரங்கள்</h3>
                    <div className="details-container">
                      {mainContentItems[activeTab].details.map((detail, i) => (
                        <div key={i} className="detail-item">
                          <span className="detail-icon">{detail.icon}</span>
                          <span className="detail-text">{detail.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {/* Modal */}
        {selectedImage && (
          <div className="modal-overlay" onClick={() => setSelectedImage(null)}>
            <div
              className="modal-contentpost"
              onClick={(e) => e.stopPropagation()}
            >
              <span
                className="modal-close"
                onClick={() => setSelectedImage(null)}
              >
                &times;
              </span>
              <img
                src={selectedImage}
                alt="Full Size"
                className="modal-image"
              />
            </div>
          </div>
        )}
      </div>
      <div className="highlights-container">
        <h1 className="highlights-main-title">
          ஆண்டுவாரியாக அழைக்கப்பட்ட தலைமை விருந்தினர்கள்
        </h1>

        <div className="tabs-container">
          {Object.keys(highlightsData).map((year) => (
            <button
              key={year}
              className={`tab-button ${activeTab1 === year ? "active" : ""}`}
              onClick={() => handleTabChange(year)}
              disabled={isTransitioning}
            >
              {year}
            </button>
          ))}
        </div>

        <div
          className={`tab-content ${isTransitioning ? "fade-out" : "fade-in"}`}
        >
          <h2 className="highlight-year-title">{displayContent.title}</h2>
          {renderContent()}
        </div>
      </div>
      {/* Full Screen Image Modal */}
      {/* <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="image-modalhm"
        overlayClassName="image-modal-overlayhm"
        ariaHideApp={false}
      >
        <button className="modal-closehm" onClick={closeModal}>
          <FaTimes />
        </button>
        <img src={selectedImage} alt="Full screen" className="modal-imagehm" />
      </ReactModal> */}
    </>
  );
};

export default Highlights;
